import { render, staticRenderFns } from "./DictionariesStandardTable.vue?vue&type=template&id=b45f1d62&scoped=true&"
import script from "./DictionariesStandardTable.vue?vue&type=script&lang=js&"
export * from "./DictionariesStandardTable.vue?vue&type=script&lang=js&"
import style0 from "./DictionariesStandardTable.vue?vue&type=style&index=0&id=b45f1d62&scoped=true&lang=scss&"
import style1 from "./DictionariesStandardTable.vue?vue&type=style&index=1&id=b45f1d62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45f1d62",
  null
  
)

export default component.exports